import React from 'react';

import HeaderThin from 'app/components/layout/HeaderThin';
import OrgInformation from './OrgInformation';
import CompetitionList from './CompetitionList';

interface IConfigurationProps {
  appReady: boolean;
  actions: any;
  match: any;
  currentOrganisation: any;
  organisations: any;
  backendErrors: any;
  errors: any;
  isLoading: boolean;
  updateOrganisation: any;
}

export default class Configuration extends React.Component<
  IConfigurationProps
> {
  static defaultProps: IConfigurationProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    organisations: undefined,
    currentOrganisation: undefined,
    backendErrors: undefined,
    isLoading: false,
    updateOrganisation: undefined,
    errors: undefined,
  };

  componentDidMount = (): void => {
    this.props.actions.getOrganisation(
      this.props.organisations.currentOrganisationId,
    );
  }

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              divider
              breadcrumb="Settings"
              breadcrumbLink="/settings"
              title="Configuration"
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-12 col-lg-8 col-xlg-6">
            <OrgInformation {...this.props} />
          </div>
        </div>
        <div className="row with-margin-top-extra">
          <div className="col col-12">
            <CompetitionList {...this.props} />
          </div>
        </div>
      </div>
    );
  }
}
